import { Report } from '../models/report.model';

export class ReportsFactory {
  public static formatReportsForTable(reports: Array<Report>) {
    let formattedReports = [];

    reports.forEach(report => {
      let formattedReport = [];

      formattedReport.push(
        {
          data: report.FileName,
          class: 'js-gtm-report',
          value: report.DocumentID,
          gtmData: JSON.stringify({ reportId: report.DocumentID })
        }
      );

      formattedReport.push(
        {
          data: report.FileType,
          class: 'js-gtm-report',
          value: report.DocumentID,
          gtmData: JSON.stringify({ reportId: report.DocumentID })
        }
      );

      const formattedDate = report.DocumentDate.split('-').join('/');
      formattedReport.push(
        {
          data: formattedDate,
          class: 'amount js-gtm-report',
          value: report.DocumentID,
          gtmData: JSON.stringify({ reportId: report.DocumentID })
        }
      );

      formattedReports.push(formattedReport)
    });

    return formattedReports;
  }
}
